import { SopStep } from '../Models';
import { StepCard } from '../Models';
export function stepCards() {
  return {
    stepCardId: ObjectId(3),
    indications: {},
    stepTittle: '',
    stepImage: null,
    hygieneRelevantStep: false,
    situational: false,
    handDisinfection: false,
    isInstitutionImage: false,
    comments: ''
  } as StepCard;
}

export function sop() {
  return {
    stepId: ObjectId(3),
    stepType: false,
    stepName: '',
    stepCards: [stepCards()],
    useStepImage: 0
  } as SopStep;
}

export function ObjectId(length) {
  const chars = '0123456789';
  let number = '';
  for (let x = 0; x < length; x++) {
    const i = Math.floor(Math.random() * chars.length);
    number += chars.charAt(i);
  }
  return parseInt(number);
}
